import {
    InputGroup,
    Input,
    InputRightElement,
    Button,
    FormControl,
    FormErrorMessage,
    InputLeftElement,
    FormHelperText
} from '@chakra-ui/react'
import { ParentSearchFormData } from './type'
import { FiSearch } from 'react-icons/fi'

interface ParentSearchFormProps {
    onSubmit: (data: ParentSearchFormData) => void
    register: any
    errors: Record<keyof any, { message?: string }>
    loading: boolean
}

export default function ParentSearchForm({
    onSubmit,
    register,
    errors,
    loading
}: ParentSearchFormProps) {
    return (
        // @ts-expect-error react-hook-form onSubmit handler typing
        <form onSubmit={onSubmit}>
            <FormControl>
                <InputGroup size="lg">
                    <InputLeftElement pointerEvents="none" pl={1}>
                        <FiSearch color="gray.300" />
                    </InputLeftElement>
                    <Input
                        placeholder="Search by name"
                        {...register('searchTerm')}
                        minW={['80vw', '400px', '600px']}
                    />
                    <InputRightElement width="max-content" pr={1}>
                        <Button type="submit" isLoading={loading}>
                            Search
                        </Button>
                    </InputRightElement>
                </InputGroup>
                <FormHelperText>Pay attention to the details & picture</FormHelperText>
                <FormErrorMessage color="red.500" fontSize="sm" mt={2}>
                    {errors.searchTerm && errors.searchTerm.message}
                </FormErrorMessage>
            </FormControl>
        </form>
    )
}
